import { Route, Routes } from "react-router-dom";
import DrawerMIC from "../../../common/components/DrawerMIC";
import routesConfig from "../../../common/utils/routesConfig";

function Home({ roles }) {
  const ProtectedRoutes = ({ userRoles }) => {
    return (
      <Routes>
        {routesConfig.map((route, index) => {
          if (route.roles.some((role) => userRoles?.includes(role))) {
            return (
              <Route
                key={index}
                path={route.path}
                element={<route.component />}
              />
            );
          }
          return null;
        })}
      </Routes>
    );
  };

  return (
    localStorage.getItem("token") && (
      <DrawerMIC content={<ProtectedRoutes userRoles={roles} />} />
    )
  );
}

export default Home;
